/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonAddressRequest = {
    sortField?: BabylonAddressRequest.sortField;
    sortDirection?: BabylonAddressRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace BabylonAddressRequest {

    export enum sortField {
        BALANCE = 'BALANCE',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

